import { Injectable } from '@angular/core';
import { CanActivate, CanActivateChild, CanDeactivate, CanLoad, Route, UrlSegment, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { UtilService } from '../service/util.service';
import { Router } from '@angular/router';
import {LocalStorageService} from 'ngx-webstorage';
import { ApiTokenService } from './api-token.service';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate, CanActivateChild, CanDeactivate<unknown>, CanLoad {
  isUserLoggedIn;
  constructor(private util: UtilService,
    private authService: ApiTokenService,
    private router: Router, private storage: LocalStorageService){
     
  }
   canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    
    return this.authService.isAuthenticated$.pipe(
      map(isAuthenticated => {
        if (isAuthenticated) {
          return true;
        } else {
          this.router.navigate(['/account/login']);
          return false;
        }
      })
    );
  }
  // canActivate(
  //   next: ActivatedRouteSnapshot,
  //   state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
  //   this.isUserLoggedIn = this.storage.retrieve('isUserLoggedIn');
  //   if(this.isUserLoggedIn){
  //     console.log(JSON.stringify('isUserLoggedIn: ' + this.isUserLoggedIn));
  //     this.storage.store('isUserLoggedIn', true);
  //   return true;
  //   }
  //   else{
  //     this.isUserLoggedIn = false;
  //     console.log(JSON.stringify('isUserLoggedIn: ' + this.isUserLoggedIn));
  //     this.storage.store('isLoggedIn', false);
  //     this.router.navigate(['/account/login']);
  //     return false;
  //   }
  // }
  canActivateChild(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return true;
  }
  canDeactivate(
    component: unknown,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState?: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return true;
  }
  canLoad(
    route: Route,
    segments: UrlSegment[]): Observable<boolean> | Promise<boolean> | boolean {
    return true;
  }
}
